import { useNavigate } from "react-router-dom";
import { MapPinIcon, CalendarIcon, UserIcon } from "@heroicons/react/24/outline";
import { useState, useEffect } from "react";
import axios from "axios";

export default function SearchBar() {
    const [form, setForm] = useState({
        destination: "",
        checkIn: "",
        checkOut: "",
        guests: 1,
    });

    const navigate = useNavigate();
    const [destinations, setDestinations] = useState([]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!form.destination.trim()) {
            alert("Please enter the destination");
            return;
        }

        navigate("/search-hotels", { state: form });
    };

    useEffect(() => {
        axios.get("https://jumeiradiscounthotels.com/api/destinations")
            .then((res) => {
                setDestinations(res.data);
            })
            .catch((err) => console.log(err));
    }, []);

    return (
        <div className="w-full max-w-7xl mx-auto">

            {/* Search Card */}
            <div className="bg-white rounded-2xl border border-gray-100 p-3 sm:p-4 shadow-[0_12px_45px_rgba(0,43,69,0.18)]">

                <form
                    onSubmit={handleSubmit}
                    className="flex flex-col lg:flex-row items-stretch lg:items-end gap-2"
                >

                    {/* Destination */}
                    <div className="flex-1 min-w-0 px-3 py-2 lg:border-r lg:border-gray-200">
                        <label className="flex items-center gap-2 text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
                            <MapPinIcon className="w-4 h-4 text-[#0F172A]" />
                            Destination
                        </label>

                        <select
                            name="destination"
                            value={form.destination}
                            onChange={handleChange}
                            className="w-full bg-transparent text-gray-900 font-medium text-sm focus:outline-none cursor-pointer"
                        >
                            <option value="">Where are you going?</option>

                            {destinations.map((dest) => (
                                <option key={dest.id} value={dest.name}>
                                    {dest.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Check-in */}
                    <div className="flex-1 min-w-0 px-3 py-2 lg:border-r lg:border-gray-200">
                        <label className="flex items-center gap-2 text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
                            <CalendarIcon className="w-4 h-4 text-[#0F172A]" />
                            Check In
                        </label>

                        <input
                            type="date"
                            name="checkIn"
                            value={form.checkIn}
                            onChange={handleChange}
                            className="w-full bg-transparent text-gray-900 font-medium text-sm focus:outline-none cursor-pointer"
                        />
                    </div>

                    {/* Check-out */}
                    <div className="flex-1 min-w-0 px-3 py-2 lg:border-r lg:border-gray-200">
                        <label className="flex items-center gap-2 text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
                            <CalendarIcon className="w-4 h-4 text-[#0F172A]" />
                            Check Out
                        </label>

                        <input
                            type="date"
                            name="checkOut"
                            value={form.checkOut}
                            onChange={handleChange}
                            className="w-full bg-transparent text-gray-900 font-medium text-sm focus:outline-none cursor-pointer"
                        />
                    </div>

                    {/* Guests */}
                    <div className="flex-1 min-w-0 px-3 py-2">
                        <label className="flex items-center gap-2 text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
                            <UserIcon className="w-4 h-4 text-[#0F172A]" />
                            Guests
                        </label>

                        <select
                            name="guests"
                            value={form.guests}
                            onChange={handleChange}
                            className="w-full bg-transparent text-gray-900 font-medium text-sm focus:outline-none cursor-pointer"
                        >
                            {[1, 2, 3, 4, 5, 6].map((num) => (
                                <option key={num} value={num}>
                                    {num} {num === 1 ? "Guest" : "Guests"}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Search Button */}
                    <div className="w-full lg:w-auto">
                        <button
                            type="submit"
                            className="w-full lg:w-auto h-12 px-8 bg-gradient-to-r from-[#002B45] via-[#174B5F] to-[#D4A83F] hover:bg-gradient-to-br  text-white font-semibold rounded-xl transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap"
                        >
                            Search Hotels
                        </button>
                    </div>

                </form>
            </div>
        </div>
    );
}
